export default __webpack_public_path__ + "static/media/2377.c32bcdb8.png";